import { z } from 'zod/v3';
import { createPaginationSchema } from '../../common/utils/schema';
import { zIsoDate } from '../../common/utils';

export const DataVersionStatusSchema = z.enum([
  'DRAFT',
  'CONFIRMED',
  'CONF_PUB',
  'CONF_PREPUB',
  'CONF_WAIT',
  'MIXED',
]);

export const ProcessingSchema = z.object({
  phaseCode: z.enum(['PENDING', 'ACTIVE', 'LAST']),
  processingTypeId: z.number().int(),
  processingMethodId: z.number().int().nullable(),
  dataProcessingScopeId: z.number().int().nullable(),
  processingTime: z.string().nullable(),
  processingStartedByUsername: z.string().nullable(),
});

export const DataObjectGroupProcessingStateSchema = z.object({
  id: z.number().int(),
  standaloneDataObjectDescriptionId: z.number().int().nullable(),
  dataObjectGroupId: z.number().int(),
  valueDate: zIsoDate(),
  dueDateTime: z.string().nullable(),
  dataObjectGroupCode: z.string(),
  dataObjectGroupName: z.string(),
  confidential: z.boolean(),
  processing: ProcessingSchema.nullable(),
  lastProcessingEndTime: z.string().nullable(),
  loadSampleErrorLevelId: z.number().int().nullable(),
  imputeErrorLevelId: z.number().int().nullable(),
  loadDataErrorLevelId: z.number().int().nullable(),
  subjectCountInData: z.number().int().nullable(),
  subjectCountInSample: z.number().int().nullable(),
  collectionRatio: z.number().nullable(),
  domainId: z.number().int().nullable(),
  frequencyId: z.number().int().nullable(),
  responsibleUserId: z.number().int().nullable(),
  responsibleUserUsername: z.string().nullable(),
  responsibleUserFirstName: z.string().nullable(),
  responsibleUserLastName: z.string().nullable(),
  hasAccess: z.boolean(),
  permissionToManage: z.boolean(),
});

export const DataObjectGroupProcessingStatePageSchema = createPaginationSchema(
  DataObjectGroupProcessingStateSchema,
);
